const ProfileIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="13" viewBox="0 0 12 13" fill="none">
      <path
        d="M6.00024 6.95067C7.04777 6.95067 7.89696 6.10148 7.89696 5.05395C7.89696 4.00642 7.04777 3.15723 6.00024 3.15723C4.95271 3.15723 4.10352 4.00642 4.10352 5.05395C4.10352 6.10148 4.95271 6.95067 6.00024 6.95067Z"
        stroke="#BDC2C5"
        strokeWidth="1.125"
      />
      <path
        d="M9.78858 10.1336V9.93919C9.78858 8.81697 8.87884 7.90723 7.75662 7.90723H4.2429C3.12068 7.90723 2.21094 8.81697 2.21094 9.93919V10.1336"
        stroke="#BDC2C5"
        strokeWidth="1.125"
      />
      <path
        d="M6 11.75C8.89949 11.75 11.25 9.39949 11.25 6.5C11.25 3.60051 8.89949 1.25 6 1.25C3.10051 1.25 0.75 3.60051 0.75 6.5C0.75 9.39949 3.10051 11.75 6 11.75Z"
        stroke="#BDC2C5"
        strokeWidth="1.125"
      />
    </svg>
  );
};

export default ProfileIcon;
